export enum AnalyticsEvent {
  ModuleViewed = "module viewed",
  ModuleOpened = "module opened",
  DashboardViewed = "dashboard viewed",
  ScenarioSubmitted = "scenario submitted",
  ScenarioReportViewed = "scenario report viewed",
  LatestDataAvailable = "latest data available",
  ScenarioCreated = "scenario created",
  ScenarioUpdated = "scenario updated",
  ScenarioFormError = "scenario form error",
  ScenarioStatusUpdated = "scenario status updated",
  ScenarioCommented = "scenario commented",
  ScenarioReportViewedSection = "scenario report section viewed",
  ScenarioSpendInputsPage = "scenario spend inputs page viewed",
  ScenarioBreakdownTableDownloaded = "scenario breakdown table downloaded",
  ButtonClicked = "button clicked",
  UnitsSelected = "units selected",
  SplitByBusinessUnit = "split by business unit",
  InsightsTableDownloaded = "insights table downloaded",
  ActionPlanCreated = "action plan created",
  SpendingPlanDownloaded = "spending plan downloaded",
  ScenarioRecommendationViewed = "scenario recommendation viewed",
  ScenarioRecommendationApprovedForActionPlan = "scenario recommendation approved for action plan",
  ScenarioApprovedForActionPlan = "scenario approved for action plan",
  ScenarioApproved = "scenario approved",
}

export enum AnalyticsDashboard {
  Review = "review",
  FinancialOverview = "financial overview",
}

export enum AnalyticsFeatures {
  ReviewChannelROI = "channel roi",
  ReviewSaturationCurves = "saturation curves",
  ReviewSalesComposition = "sales composition",
  ReviewBrandEquity = "brand equity",
  ReviewChannelOpportunities = "channel opportunities",
  ReviewEnvironmentalFactors = "environmental factors",
  CFOSalesSummary = "sales summary",
  CFOSalesDistribution = "sales distribution",
  CFOSalesBreakdown = "sales breakdown",
}
